import base from "../baseurl";
import token from "../getTk";

const Show = async (uuid) => {
  const tokenA = token.get();

  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const status = await api
    .post("other-assembly-members/delete", {
      json: { userUuid: uuid },
    })
    .json();
  console.log(status);
  return status;
};

export default Show;
